import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Herosection from '../components/home/Herosection';
import Footer from '../components/Footer';
import Purposesection from '../components/home/Purposesection';
import StrainsSection from '../components/home/Strains';
import AboutUs from '../components/home/Aboutus';
import WhyWorkWithUs from '../components/home/WhyWorkWithUs';
import { FaArrowUp } from "react-icons/fa";

const Home = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
    <Helmet>
        <title>Beyond Bloom | Premium Cannabis & Wellness</title>
        <meta name="description" content="Experience the pinnacle of cannabis excellence with Beyond Bloom. Explore our premium, organic strains designed for wellness, relaxation, and an elevated lifestyle." />
        <meta name="keywords" content="Beyond Bloom, premium cannabis, organic cannabis, high-quality strains, wellness-focused cannabis, natural cannabis products, elevate your senses, cannabis for relaxation" />
        <meta property="og:title" content="Beyond Bloom | Premium Cannabis & Wellness" />
        <meta property="og:description" content="Explore Beyond Bloom’s finest cannabis strains, crafted for purity, potency, and a transformative experience. Elevate your wellness journey today." />
        <meta property="og:image" content="/path-to-social-preview-image.jpg" />
        <meta property="og:url" content="https://beyondbloom.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Navbar />
      <Herosection />
      <Purposesection />
      <StrainsSection />
      <AboutUs />
      <WhyWorkWithUs />
      <Footer />

      {/* Scroll to Top Button (Hidden on Mobile) */}
      {showScroll && (
        <button
          onClick={scrollToTop}
          className="hidden md:flex fixed bottom-6 right-6 p-4 bg-green-500 text-white rounded-full shadow-lg hover:bg-green-600 transition duration-300 items-center justify-center w-14 h-14"
          aria-label="Scroll to top"
        >
          <FaArrowUp size={24} />
        </button>
      )}
    </>
  );
};

export default Home;